import styled from "styled-components";

export const SummaryCard = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
`;

export const SummaryHeader = styled.div`
  padding: 14px 16px;
  background: linear-gradient(135deg, #334155 0%, #475569 100%);
  display: flex;
  align-items: center;
  gap: 10px;
  
  h4 {
    margin: 0;
    color: white;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const SummaryBody = styled.div`
  padding: 16px;
`;

export const SummaryRow = styled.div<{ isTotal?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.isTotal ? '14px 0' : '10px 0'};
  border-bottom: ${props => props.isTotal ? 'none' : '1px solid #f1f5f9'};
  
  ${props => props.isTotal && `
    margin-top: 8px;
    border-top: 2px solid #e2e8f0;
  `}
`;

export const SummaryLabel = styled.span<{ isTotal?: boolean }>`
  font-size: ${props => props.isTotal ? '16px' : '14px'};
  font-weight: ${props => props.isTotal ? '700' : '500'};
  color: ${props => props.isTotal ? '#1e293b' : '#64748b'};
`;

export const SummaryValue = styled.span<{ isTotal?: boolean; isDiscount?: boolean; showValue?: boolean }>`
  font-size: ${props => props.isTotal ? '20px' : '14px'};
  font-weight: ${props => props.isTotal ? '700' : '600'};
  color: ${props => {
    if (!props.showValue) return '#94a3b8';
    if (props.isDiscount) return '#ef4444';
    if (props.isTotal) return '#10b981';
    return '#1e293b';
  }};
`;

export const DescontoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DescontoInput = styled.input<{ disabled?: boolean }>`
  width: 100px;
  padding: 8px 12px;
  border: 2px solid ${props => props.disabled ? '#e2e8f0' : '#3b82f6'};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-align: right;
  color: ${props => props.disabled ? '#94a3b8' : '#ef4444'};
  background: ${props => props.disabled ? '#f8fafc' : 'white'};
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  }
`;

export const AuthorizeButton = styled.button`
  padding: 8px 14px;
  border: 2px solid #f59e0b;
  border-radius: 8px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #d97706;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: linear-gradient(135deg, #fde68a 0%, #fcd34d 100%);
  }
`;

export const DescontoArea = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #e2e8f0;
`;

export const DescontoLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 6px;
`;

export const DescontoTextarea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  resize: none;
  min-height: 60px;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  &::placeholder {
    color: #94a3b8;
  }
`;

export const ConfigCard = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
`;

export const ConfigHeader = styled.div`
  padding: 14px 16px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  display: flex;
  align-items: center;
  gap: 10px;
  
  h4 {
    margin: 0;
    color: white;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const ConfigBody = styled.div`
  padding: 16px;
`;

export const ConfigGroup = styled.div`
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ConfigLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
`;

export const ConfigInput = styled.input`
  width: 100%;
  padding: 12px 14px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  &::placeholder {
    color: #94a3b8;
  }
`;

export const PasswordModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`;

export const PasswordContent = styled.div`
  background: white;
  border-radius: 20px;
  width: 100%;
  max-width: 350px;
  padding: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

export const PasswordTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 18px;
  color: #1e293b;
  text-align: center;
`;

export const PasswordInput = styled.input`
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 16px;
  text-align: center;
  margin-bottom: 16px;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
  }
`;

export const PasswordButtons = styled.div`
  display: flex;
  gap: 12px;
`;

export const PasswordButton = styled.button<{ variant?: 'primary' | 'secondary' }>`
  flex: 1;
  padding: 14px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  ${props => props.variant === 'primary' ? `
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border: none;
    color: white;
    
    &:hover {
      box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
    }
  ` : `
    background: white;
    border: 2px solid #e2e8f0;
    color: #64748b;
    
    &:hover {
      border-color: #94a3b8;
    }
  `}
`;

export const ErrorMessage = styled.p`
  color: #ef4444;
  font-size: 13px;
  text-align: center;
  margin: 0 0 12px 0;
`;

